import { ChangeDetectionStrategy, Component, computed, inject, input, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { TaxonomyTreeStore } from 'libs/shared/feature-taxonomy-tree/api';
import { BreadcrumbComponent } from 'shared/ui-common';

import { Taxonomy } from '@treetop/shared/model';

@Component({
  standalone: true,
  imports: [BreadcrumbComponent, TranslocoModule, MatIconModule],
  selector: 'tt-taxonomy-breadcrumb',
  templateUrl: './tt-taxonomy-breadcrumb.component.html',
  styleUrls: ['./tt-taxonomy-breadcrumb.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaxonomyBreadcrumbComponent {
  protected taxonomyTreeStore = inject(TaxonomyTreeStore);

  public taxonomies = input<Taxonomy[]>([]);

  protected hideBreadcrumb = signal(true);

  protected breadcrumbs = computed(() => {
    const taxonomies = (this.taxonomies() ?? []).map((taxonomy) => taxonomy.id);
    const flatTaxonomy = this.taxonomyTreeStore.vm().flatTaxonomy;

    if (!taxonomies || Object.keys(flatTaxonomy).length === 0) {
      return [];
    }

    return taxonomies.map((taxonomy) => this.mapTaxonomyToValueLabel(taxonomy, flatTaxonomy)).filter((breadcrumb) => breadcrumb.length > 0);
  });

  private mapTaxonomyToValueLabel(taxonomyId: string, taxonomies: Record<string, Taxonomy>): { value: string; label: string }[] {
    const breadcrumbs: { value: string; label: string }[] = [];

    let current: Taxonomy | undefined = taxonomies[taxonomyId];

    while (current?.id) {
      breadcrumbs.push({
        value: current.id,
        label: current.title ?? '',
      });

      if (!current.parentId) {
        break;
      }

      current = taxonomies[current.parentId];
    }

    return breadcrumbs.reverse();
  }
}
